import React from 'react';

import { MenuButton } from './menu-button';
import { MenuDropdown } from './menu-dropdown';

export function CollapsibleMenu({ id, navPages, menuIcon, desktopIcon }) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const toggleMenu = event => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <MenuButton toggleMenu={toggleMenu} menuIcon={menuIcon} desktopIcon={desktopIcon} id={id} />
            <MenuDropdown anchorEl={anchorEl} onClose={handleCloseMenu} navPages={navPages} />
        </>
    );
}
